import './App.css';
import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import ReactGA from 'react-ga';

//ContextProviders
import { LoadingProvider } from './assets/js/ContextProviders/LoadingContext';
import { AccountProvider } from './assets/js/ContextProviders/AccountContext';
import { CalculatorProvider } from './assets/js/ContextProviders/CalculatorContext';
import { OnScreenProvider } from './assets/js/ContextProviders/OnScreenContext';

//pages:
import Layout from './MyComponents/Layout';
import Home from './pages/Home';
import Products from './pages/Products';
import Cart from './pages/Cart';
import Nopage from './pages/NoPage';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ComplainForm from './pages/ComplainForm';
import Franchise from './pages/Franchise';
import EmployForm from './pages/EmployForm';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Reviews from './pages/Reviews';
import MyAccount from './pages/MyAccount';
import SearchPage from './pages/SearchPage';
import Orders from './pages/Orders'
import AdminPanel from './pages/AdminPanel';

import DraggableImage from './pages/test';
function App() {
  return (
    <>
      <OnScreenProvider>
        <CalculatorProvider>
          <AccountProvider>
            <LoadingProvider>
              <BrowserRouter>
                <Routes>
                  <Route path="/" element={<Layout body={<Home />} />} />
                  <Route path="products" element={<Layout body={<Products />} />} />
                  <Route path="login" element={<Layout body={<Login />} />} />
                  <Route path="signup" element={<Layout body={<Signup />} />} />
                  <Route path="cart" element={<Layout body={<Cart />} />} />
                  <Route path="complaint-form" element={<Layout body={<ComplainForm />} />} />
                  <Route path="franchise-opportunity" element={<Layout body={<Franchise />} />} />
                  <Route path="jobs-opportunities" element={<Layout body={<EmployForm />} />} />
                  <Route path="privacy-policy" element={<Layout body={<PrivacyPolicy />} />} />
                  <Route path="reviews" element={<Layout body={<Reviews />} />} />
                  <Route path="reviews" element={<Layout body={<Reviews />} />} />
                  <Route path="your-account" element={<Layout body={<MyAccount />} />} />
                  <Route path="search" element={<Layout body={<SearchPage />} />} />
                  <Route path="orders" element={<Layout body={<Orders />} />} />
                  <Route path="a" element={<Layout body={<DraggableImage />} />} />
                  <Route path="admin-panel" element={<Layout body={<AdminPanel />} />} />
                  <Route path="*" element={<Nopage />} />
                </Routes>
              </BrowserRouter>
            </LoadingProvider>
          </AccountProvider>
        </CalculatorProvider>
      </OnScreenProvider>
    </>
  );
}

export default App;
